import produce from 'utils/produce';

// The source item is kept, callers remove it once nothing renders it anymore.
export const copyEditorItem = (editorStore, id, newId) => {
  if (id === newId || !editorStore.items[id]) {
    return editorStore;
  }

  return produce(editorStore, draft => {
    draft.items[newId] = editorStore.items[id];
  });
};
